// extracted by mini-css-extract-plugin
export default {"postCards":"user-post-list_postCards__wUgJL","userPost":"user-post-list_userPost__PEDbx"};